import React from 'react';
import {
  TableRow,
  TableCell,
  Typography,
  MenuList,
  MenuItem,
  Paper,
} from '@mui/material';
import { MoreVert } from '@mui/icons-material';

import { DialogContext, LocalizationContext, PermissionContext } from '@cvt/contexts';
import { IconButtonDropdown } from '@cvt/components/ButtonDropdown';
import { useRouter } from '@cvt/routing';

import { useCompanyCrud } from '../../../hooks/useCompanyCrud';


export const CompanyRow: React.FC<Companies.Company> = (company) => {
  const router = useRouter();

  const { dictionary } = React.useContext(LocalizationContext);
  const { asyncConfirmation } = React.useContext(DialogContext);
  const { permissions } = React.useContext(PermissionContext);

  const { deleteCompany } = useCompanyCrud();

  const onDelete = React.useCallback(async () => {
    const userConfirmed = await asyncConfirmation({ title: dictionary.users.edit.deleteConfirmation });
    if (!deleteCompany || !userConfirmed) {
      return false;
    }
    return deleteCompany(company.id);
  }, [company, deleteCompany, asyncConfirmation, dictionary]);

  return (
    <TableRow component={Paper} elevation={1}>
      <TableCell component="th" scope="row">
        <Typography variant="subtitle1">{company.name}</Typography>
        <Typography variant="subtitle2">{company.createdAt.toISOString()}</Typography>
      </TableCell>
      <TableCell align="right">
        {(permissions.companies.edit || permissions.companies.delete) && (
          <IconButtonDropdown
            placement="bottom-start"
            buttonProps={{
              color: 'secondary',
            }}
            content={({ closeDropdown }) => (
              <MenuList>
                {permissions.companies.edit && (
                  <MenuItem
                    onClick={() => {
                      router.companies.edit(company.id).go();
                      closeDropdown();
                    }}
                  >
                    {dictionary.users.edit.buttonEdit}
                  </MenuItem>
                )}
                {permissions.companies.delete && (
                  <MenuItem
                    onClick={() => {
                      onDelete();
                      closeDropdown();
                    }}
                  >
                    {dictionary.companies.edit.buttonDelete}
                  </MenuItem>
                )}
              </MenuList>
            )}
          >
            <MoreVert/>
          </IconButtonDropdown>
        )}
      </TableCell>
    </TableRow>
  );
};
